    export * from './window-type-5.component';